import React from 'react';
import AreaChart from '@cloudscape-design/components/area-chart';
import BarChart from '@cloudscape-design/components/bar-chart';
import Box from '@cloudscape-design/components/box';
import LineChart from '@cloudscape-design/components/line-chart';
import MixedLineBarChart from '@cloudscape-design/components/mixed-line-bar-chart';
import PieChart from '@cloudscape-design/components/pie-chart';

interface ChartRendererProps {
    type: 'line-chart' | 'bar-chart' | 'area-chart' | 'pie-chart' | 'mixed-chart';
    props: any;
}

export const ChartRenderer: React.FC<ChartRendererProps> = ({type, props}) => {
    const defaultEmpty = (
        <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
                There is no data available
            </Box>
        </Box>
    );

    const chartProps = {
        ...props,
        empty: defaultEmpty,
        height: 200,
        fitHeight: true,
    };

    return (
        <div style={{width: '100%', height: '100%', minHeight: '200px'}}>
            {(() => {
                switch (type) {
                    case 'line-chart':
                        return <LineChart {...chartProps} />;
                    case 'bar-chart':
                        return <BarChart {...chartProps} />;
                    case 'area-chart':
                        return <AreaChart {...chartProps} />;
                    case 'pie-chart':
                        return <PieChart {...chartProps} />;
                    case 'mixed-chart':
                        return <MixedLineBarChart {...chartProps} />;
                    default:
                        return (
                            <Box textAlign="center" color="inherit">
                                <b>Unsupported chart type: {type}</b>
                            </Box>
                        );
                }
            })()}
        </div>
    );
};
